<template lang="pug">
  .marketing-task-skeleton
    SkeletonItem(className='skeleton-title')
    .skeleton-content
      SkeletonItem(className='skeleton-icon')
      .skeleton-main
        SkeletonItem(className='skeleton-task-name')
        SkeletonItem(className='skeleton-progress')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'MarketingTaskSkeleton',
  components: {
    SkeletonItem,
  },
};
</script>

<style lang="less" scoped>
.marketing-task-skeleton {
  padding: 0.16rem 0.12rem 0.14rem;
  background-color: #fff;
  border-radius: 0.16rem;

  .skeleton-title {
    width: 1.2rem;
    height: 0.21rem;
  }

  .skeleton-content {
    display: flex;
    margin-top: 0.14rem;

    .skeleton-icon {
      width: 0.44rem;
      height: 0.44rem;
      border-radius: 0.12rem;
      flex-shrink: 0;
    }

    .skeleton-main {
      margin-left: 0.09rem;
      flex: 1;

      .skeleton-task-name {
        width: 1.2rem;
        height: 0.21rem;
      }

      .skeleton-progress {
        margin-top: 0.06rem;
        width: 1.86rem;
        height: 0.18rem;
      }
    }
  }
}
</style>
